var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 20C23.525 20 28 15.525 28 10C28 4.475 23.525 0 18 0C12.475 0 8 4.475 8 10C8 15.525 12.475 20 18 20ZM26 10C26 14.42 22.42 18 18 18C13.58 18 10 14.42 10 10C10 5.58 13.58 2 18 2C22.42 2 26 5.58 26 10ZM23.035 21.874L20 30.544V30L19.425 25.979C19.6086 25.9403 19.7775 25.8508 19.9126 25.7207C20.0477 25.5905 20.1435 25.425 20.189 25.243L20.689 23.243C20.7259 23.0956 20.7288 22.9418 20.6973 22.7932C20.6659 22.6445 20.601 22.505 20.5076 22.3852C20.4142 22.2654 20.2948 22.1684 20.1583 22.1017C20.0218 22.0349 19.8719 22.0002 19.72 22H16.282C16.1301 22 15.9802 22.0347 15.8437 22.1013C15.7072 22.1679 15.5877 22.2648 15.4942 22.3845C15.4007 22.5042 15.3357 22.6436 15.3041 22.7922C15.2725 22.9408 15.2752 23.0946 15.312 23.242L15.812 25.242C15.8573 25.4242 15.953 25.5899 16.0881 25.7202C16.2232 25.8506 16.3923 25.9403 16.576 25.979L16.014 29.911L12.96 21.863L12.94 21.82C12.7924 21.517 12.5459 21.2735 12.2411 21.1297C11.9364 20.9859 11.5917 20.9503 11.264 21.029C10.923 21.112 10.547 21.199 10.15 21.293C9.213 21.512 8.156 21.759 7.154 22.038C5.741 22.432 4.277 22.928 3.26 23.596C1.387 24.826 0 26.453 0 28.5V36H36V28.5C36 26.453 34.614 24.825 32.74 23.596C31.724 22.928 30.26 22.432 28.847 22.038C27.8535 21.7691 26.8547 21.5208 25.851 21.293C25.4793 21.2067 25.1079 21.1187 24.737 21.029C24.4095 20.9506 24.065 20.9862 23.7605 21.1301C23.4559 21.2739 23.2095 21.5172 23.062 21.82L23.035 21.874ZM25.444 23.252L24.731 23.084L20.909 34H34V28.5C34 27.454 33.296 26.353 31.643 25.268C30.909 24.785 29.713 24.355 28.311 23.965C27.3607 23.7075 26.4042 23.4698 25.444 23.252ZM11.282 23.081L15.425 34H2V28.5C2 27.454 2.704 26.353 4.357 25.268C5.091 24.785 6.287 24.355 7.689 23.965C8.63921 23.7072 9.59476 23.4695 10.555 23.252L11.282 23.081Z",
    fill: "url(#paint0_linear_1714_4872)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4872",
    x1: 8.53968e-7,
    y1: -4.5,
    x2: 38.3778,
    y2: 37.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr9);
export default __webpack_public_path__ + "static/media/Hr9.ed3dd24af7f64dd26f7fa3b9761a8c19.svg";
export { ForwardRef as ReactComponent };